<template>
  <div class="user_page inventory_page">
    <div class="admin_main">
      <div class="admin_container">
        <h3 class="inventory_title">{{ $t("reportInventory") }}</h3>
        <div class="division_main inventory_main_table">
          <div class="inventory_table">
            <table-with-filter :headers="headers" :items="items">
              <template #filter.startedAt>
                <div class="data_block d-flex align-center">
                  <span class="custom_input_label pt-1 mr-2">{{
                    $t("from")
                  }}</span>
                  <custom-date-picker
                    clearable
                    @input="getInventoryByFilter"
                    v-model="inventoryConfiguration.filter.startFromDate"
                    hide-details
                    color="#E3EBF3"
                    class="mr-1 user_input ml-1 data_item data_item_calendar"
                    icon="mdi-calendar-month small"
                  ></custom-date-picker>
                  <span class="custom_input_label pt-1">{{ $t("to") }}</span>
                  <custom-date-picker
                    hide-details
                    clearable
                    :min="inventoryConfiguration.filter.startFromDate"
                    @input="getInventoryByFilter"
                    :start-day="false"
                    v-model="inventoryConfiguration.filter.startToDate"
                    name="calendar_t"
                    color="#E3EBF3"
                    class="user_input data_input_tw data_item ml-2 data_item"
                    icon="mdi-calendar-month small"
                  ></custom-date-picker>
                </div>
              </template>
              <template
                #item.startedAt="{
                  item,
                  /**
                   * @type Object
                   * @property startedAt
                   */
                }"
              >
                {{ dateParseToString(item.startedAt) }}
              </template>
              <template
                #item.inventory="{ item: { validsCount, invalidsCount } }"
              >
                <div class="py-1">
                  <p class="mb-1">
                    {{ $t("numberOfValidProducts") }}
                    <b class="color-green">{{ validsCount }}</b>
                  </p>
                  <p class="mb-0">
                    {{ $t("numberOfInvalidProducts") }}
                    <b class="error--text">{{ invalidsCount }}</b>
                  </p>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="
                        $router.push({
                          name: 'inventories-item',
                          params: { id: item.id },
                        })
                      "
                      v-bind="attrs"
                      v-on="on"
                      class="btn_33 edit_btn disabled"
                      outlined
                    >
                      <vue-icon icon="eyeIcon"></vue-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("more") }}</span>
                </v-tooltip>
              </template>
            </table-with-filter>
            <vue-pagination
              @update:limit="
                (limit) => {
                  inventoryConfiguration.pagination.limit = limit;
                  inventoryConfiguration.pagination.page = 1;
                  changePage();
                }
              "
              v-model="inventoryConfiguration.pagination.page"
              :length="lastPage"
              @input="changePage"
              go-to
              :limit="inventoryConfiguration.pagination.limit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateParseToString, makerPagination } from "@/utils/pureFunctions";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import TableWithFilter from "@/components/ui/table/TableWithFilter";

export default {
  name: "inventory-table",
  components: { TableWithFilter, VuePagination },
  data: () => ({
    ready: false,
    items: [],
    users: [],
    lastPage: 0,
    inventoryConfiguration: {
      pagination: {
        page: 1,
        limit: 10,
      },
      filter: {
        /**
         * @type Object
         * @property startFromDate
         * @property startToDate
         */
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["startedAt"],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      },
    },
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("date"),
          value: "startedAt",
        },
        { text: this.$t("inventory"), value: "inventory" },
        { text: this.$t("whoProduced"), value: "auditor" },
        { text: this.$t("action"), value: "actions", sortable: false },
      ];
    },
  },
  methods: {
    dateParseToString: dateParseToString,
    async changePage(val) {
      const { page: queryPage } = this.$route.query;
      if (queryPage !== val.toString()) {
        await this.$router.push({ query: { page: val } });
        await this.getInventoryWithLoading();
      }
    },
    getInventoryByFilter() {
      const { page: queryPage } = this.$route.query;
      if (queryPage !== "1") {
        this.inventoryConfiguration.pagination.page = 1;
        this.$router.push({ query: { page: "1" } });
      }
      this.getInventoryWithLoading();
    },
    async getInventoryWithLoading() {
      if (this.ready) {
        this.showLoading();
        await this.getInventories();
        this.clearLoading();
      }
    },
    async getInventories() {
      try {
        let params = { ...this.inventoryConfiguration.filter };
        const { page, limit } = this.inventoryConfiguration.pagination;
        const {
          sortBy: [sortBy],
          sortDesc: [sortDirection],
        } = this.inventoryConfiguration.options;
        params.page = page - 1;
        params.limit = limit;
        params.sortBy = sortBy;
        params.sortDirection = sortDirection;
        const {
          data: { data, total },
        } = await this.$http.get("inventarization/list", {
          params,
        });

        this.items = data;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async mounted() {
    this.showLoading();
    try {
      const { page } = this.$route.query;
      if (page) {
        this.inventoryConfiguration.pagination.page = +page;
      }
      const {
        data: { data },
      } = await this.$store.dispatch("getUsers");
      this.users = data;
      await this.getInventories();
      this.ready = true;
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
};
</script>
